// @generated by protoc-gen-es v2.10.1
// @generated from file auth/v1/messages.proto (package datifyy.auth.v1, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_types } from "../../common/v1/types_pb";

/**
 * Describes the file auth/v1/messages.proto.
 */
export const file_auth_v1_messages = /*@__PURE__*/
  fileDesc("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", [file_common_v1_types]);

/**
 * Describes the message datifyy.auth.v1.EmailPasswordCredentials.
 * Use `create(EmailPasswordCredentialsSchema)` to create a new message.
 */
export const EmailPasswordCredentialsSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_messages, 0);

/**
 * Describes the message datifyy.auth.v1.PhoneOTPCredentials.
 * Use `create(PhoneOTPCredentialsSchema)` to create a new message.
 */
export const PhoneOTPCredentialsSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_messages, 1);

/**
 * Describes the message datifyy.auth.v1.AccessToken.
 * Use `create(AccessTokenSchema)` to create a new message.
 */
export const AccessTokenSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_messages, 2);

/**
 * Describes the message datifyy.auth.v1.RefreshToken.
 * Use `create(RefreshTokenSchema)` to create a new message.
 */
export const RefreshTokenSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_messages, 3);

/**
 * Describes the message datifyy.auth.v1.TokenPair.
 * Use `create(TokenPairSchema)` to create a new message.
 */
export const TokenPairSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_messages, 4);

/**
 * Describes the message datifyy.auth.v1.SessionInfo.
 * Use `create(SessionInfoSchema)` to create a new message.
 */
export const SessionInfoSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_messages, 5);

/**
 * Describes the message datifyy.auth.v1.DeviceInfo.
 * Use `create(DeviceInfoSchema)` to create a new message.
 */
export const DeviceInfoSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_messages, 6);

/**
 * Describes the message datifyy.auth.v1.VerificationCode.
 * Use `create(VerificationCodeSchema)` to create a new message.
 */
export const VerificationCodeSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_messages, 7);

/**
 * Describes the message datifyy.auth.v1.VerificationRequest.
 * Use `create(VerificationRequestSchema)` to create a new message.
 */
export const VerificationRequestSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_messages, 8);

/**
 * Describes the message datifyy.auth.v1.PasswordResetRequest.
 * Use `create(PasswordResetRequestSchema)` to create a new message.
 */
export const PasswordResetRequestSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_messages, 9);

/**
 * Describes the message datifyy.auth.v1.PasswordResetConfirm.
 * Use `create(PasswordResetConfirmSchema)` to create a new message.
 */
export const PasswordResetConfirmSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_messages, 10);

/**
 * Describes the message datifyy.auth.v1.UserProfile.
 * Use `create(UserProfileSchema)` to create a new message.
 */
export const UserProfileSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_messages, 11);

/**
 * Describes the message datifyy.auth.v1.DeviceSession.
 * Use `create(DeviceSessionSchema)` to create a new message.
 */
export const DeviceSessionSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_messages, 12);

/**
 * Describes the message datifyy.auth.v1.DeviceList.
 * Use `create(DeviceListSchema)` to create a new message.
 */
export const DeviceListSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_messages, 13);

/**
 * Describes the message datifyy.auth.v1.OAuthCredentials.
 * Use `create(OAuthCredentialsSchema)` to create a new message.
 */
export const OAuthCredentialsSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_messages, 14);

/**
 * Describes the enum datifyy.auth.v1.VerificationType.
 */
export const VerificationTypeSchema = /*@__PURE__*/
  enumDesc(file_auth_v1_messages, 0);

/**
 * Verification type enum
 *
 * @generated from enum datifyy.auth.v1.VerificationType
 */
export const VerificationType = /*@__PURE__*/
  tsEnum(VerificationTypeSchema);

/**
 * Describes the enum datifyy.auth.v1.OAuthProvider.
 */
export const OAuthProviderSchema = /*@__PURE__*/
  enumDesc(file_auth_v1_messages, 1);

/**
 * OAuth provider enum
 *
 * @generated from enum datifyy.auth.v1.OAuthProvider
 */
export const OAuthProvider = /*@__PURE__*/
  tsEnum(OAuthProviderSchema);

